import { Dialog, DialogContent } from '@/common/ui/dialog'
import { H3 } from '@/common/ui/h3'
import useOrderReviewStore from './orderReviewStore'
import { Alert } from '@/common/ui/alert'
import { AlertTriangle } from 'lucide-react'
import { Button } from '@/common/ui'
import { ORDER_FILL_CANCELLATION_COPY } from '@/locales/en'

type Props = {
    open: boolean
    cancelingOrder: boolean
    onClose: () => void
    onSubmit: () => void
}

export default function CancelUnfilledModal(props: Props) {
    const { open, onClose, onSubmit, cancelingOrder } = props
    const { currentOrder } = useOrderReviewStore()

    if (!currentOrder) return null

    const unfilledShares = currentOrder.units - (currentOrder.orderCompletionUnits ?? 0)

    return (
        <Dialog open={open}>
            <div className="absolute py-10 h-screen">
                <DialogContent onClose={onClose} className="py-14 w-[400px] sm:w-[600px]">
                    <div className="self-stretch flex flex-col justify-start items-start gap-6">
                        <div className="self-stretch flex flex-col justify-start items-start">
                            <H3 className="self-stretch text-center justify-start text-black text-3xl font-normal font-['Serious Sans'] leading-8">
                                {ORDER_FILL_CANCELLATION_COPY.title}
                            </H3>
                        </div>
                        <div className="self-stretch text-center justify-start text-black text-base font-normal font-['Inter']">
                            <span className="text-black text-base font-normal font-['Inter'] leading-6">
                                {ORDER_FILL_CANCELLATION_COPY.content[0]
                                    .replace('{filled}', `${currentOrder.orderCompletionUnits ?? 0}`)
                                    .replace('{requested}', `${currentOrder.units}`)}
                            </span>
                            <span className="font-semibold leading-6">
                                {ORDER_FILL_CANCELLATION_COPY.content[1].replace('{unfilled}', `${unfilledShares}`)}
                            </span>
                            <span className="leading-6">{ORDER_FILL_CANCELLATION_COPY.content[2]}</span>
                            <span className="font-semibold leading-6">
                                {ORDER_FILL_CANCELLATION_COPY.content[3].replace(
                                    '{securityCode}',
                                    `${currentOrder.securityCode}`,
                                )}
                            </span>
                            <span className="leading-6">{ORDER_FILL_CANCELLATION_COPY.content[4]}</span>
                        </div>
                        <Alert className="bg-yellow-50 outline-yellow-700 inline-flex justify-start items-center gap-2.5">
                            <div className="self-stretch inline-flex justify-start items-start gap-4">
                                <div className="flex-1 flex justify-start items-start gap-4">
                                    <AlertTriangle className="w-5 h-5 text-yellow-700" />
                                </div>
                                <div className="self-stretch inline-flex flex-col justify-center items-start gap-2">
                                    <div className="justify-center text-content-primary text-sm font-medium font-['Inter'] leading-5">
                                        {ORDER_FILL_CANCELLATION_COPY.warning.title}
                                    </div>
                                    <div className="self-stretch justify-start text-content-primary text-sm font-normal font-['Inter'] leading-5">
                                        {ORDER_FILL_CANCELLATION_COPY.warning.content}
                                    </div>
                                </div>
                            </div>
                        </Alert>
                        <div className="self-stretch inline-flex justify-center items-center gap-6">
                            <Button
                                variant="tertiary"
                                disabled={cancelingOrder}
                                size="lg"
                                className="w-max m-auto"
                                onClick={onClose}
                            >
                                {ORDER_FILL_CANCELLATION_COPY.back}
                            </Button>
                            <Button
                                variant="destructive"
                                loading={cancelingOrder}
                                size="lg"
                                className="w-max m-auto"
                                onClick={onSubmit}
                            >
                                {ORDER_FILL_CANCELLATION_COPY.confirm}
                            </Button>
                        </div>
                    </div>
                </DialogContent>
            </div>
        </Dialog>
    )
}
